import moment from "moment";
import { nbfgetAccountSetting } from "../../../api/restApi";
import { GetMaxCode } from "../../../utils/Level/utils";
import { saveLevel3, saveNewVoucher } from "../../../utils/endPoints";

//  create voucher class
export class Voucher {
  constructor() {
    this.voucherRecBy = "";
    this.voucherDepBy = "";
    this.invoiceBillNum = "";
    this.description = "";
    this.balance = "";
    this.site = "";
    this.voucherItems = [];
    this.voucherDate = moment().format("DD/MM/YYYY");
    this.lockStatus = false;
  }
}

// import { PaymentOptions } from "./Utlis";
export const genericVoucherData = {
  voucherRecBy: "",
  voucherDepBy: "",
  invoiceBillNum: "",
  description: "",
  balance: "",
  site: 1,
  id:1,
  voucherItems: [],
  voucherDate: moment().format("DD/MM/YYYY"),
  lockStatus: false,
};
export function EncodeLevel2Code(maxCode) {
  let newCode = "";
  if (maxCode < 10) {
    newCode = "00" + maxCode;
  } else if (maxCode >= 10 && maxCode < 100) {
    newCode = "0" + maxCode;
  } else {
    newCode = "" + maxCode;
  }
  return newCode;
}
export async function CreateNewCustomer(
  selectedCustomer,
  level_3,
  arrearAmount
) {
  if (arrearAmount === "") {
    arrearAmount = 0;
  }
  let d = selectedCustomer;
  let tempArray = level_3.filter(function (el) {
    return el.fullcode.startsWith("07-006");
  });
  console.log(tempArray);
  let code = EncodeLevel3Code(GetMaxCode(tempArray));

  let customer_id = selectedCustomer.id;
  delete d.id;

  let cust = {
    ...d,
    type: "CLIENT",
    freeze: "NO",
    customer_id,
    description: d.name_english,
    l1code: "07",
    l2code: "07-006",
    code: code,
    fullcode: "07-006-" + code,
    name: d.name_english,
    address: d.address_english,
    contact: "234",
    debit: arrearAmount >= 0 ? arrearAmount : "",
    credit: arrearAmount < 0 ? arrearAmount : "",
    amount: Math.abs(arrearAmount),
    transactionType: arrearAmount >= 0 ? "Debit" : "Credit",
  };
  console.log(cust);
  let res = await saveLevel3(cust.fullcode, cust);
  console.log(cust);
  return res;
}
export function EncodeLevel3Code(maxCode) {
  let newCode = "";
  if (maxCode < 10) {
    newCode = "000" + maxCode;
  } else if (maxCode >= 10 && maxCode < 100) {
    newCode = "00" + maxCode;
  } else if (maxCode >= 100 && maxCode < 1000) {
    newCode = "0" + maxCode;
  } else {
    newCode = "" + maxCode;
  }
  return newCode;
}
export function getAccountCodeForCustomer(level3, id) {
  console.log(level3, id);
  const levelTypeClient = level3.filter((el) => el.type === "CLIENT");
  console.log(levelTypeClient, id);
  let customer = levelTypeClient.find(
    (customer) => customer.customer_id + "" === id + ""
  );
  console.log(customer);
  return customer.fullcode;
}

export function isCodeAvailable(dataArray, code) {
  for (var index = 0; index < dataArray.length; ++index) {
    let row = parseInt(dataArray[index].code.split("-").pop(), 10);
    if (row + "" === code) {
      return false;
    }
  }
  return true;
}

export const columns = [
  { field: "id", headerName: "Sr#", width: 100 },
  { field: "fullcode", headerName: "Code", width: 140 },
  { field: "Discription", headerName: "Description", width: 300 },
];

export const columns1 = [
  { field: "id", headerName: "Sr#", width: 100 },
  { field: "code", headerName: "Code", width: 140 },
  { field: "Discription", headerName: "Description", width: 300 },
];

export const level3CodeType = [
  "BANK",
  "CASH",
  "EXPENSES",
  "CLIENT",
  "SUPPLIER",
  "JOURNAL",
  "SALE",
];

export async function createSupplyPurchaseVoucher(
  supplierCode,
  supplierName,
  amount,
  amountPaid,
  paymentCode,
  paymentParticular,
  paymentDesc
) {
  // const voucherData = {
  //   ...data,
  //   type: name,

  // };

  // delete voucherData.voucherRecCode;
  // delete voucherData.voucherParticular;
  // delete voucherData.voucherDesc;

  const accountData = await nbfgetAccountSetting();
  let dataCash = accountData.PaymentCash.split(",").map((item) => item.trim());
  let voucher = new Voucher();
  voucher.voucherRecBy = "";
  voucher.voucherDepBy = "";
  voucher.invoiceBillNum = "";
  voucher.description = "";
  voucher.balance = "";
  voucher.type = "EXPENSE";
  voucher.voucherDate = moment().utcOffset("+05:00").format("DD/MM/YYYY");
  voucher.voucherTime = moment().utcOffset("+05:00").format("HH:mm:ss");
  voucher.lockStatus = false;
  voucher.voucherItems = [
    {
      transaction: "Debit",
      debit: amount,
      credit: "",
      amount: amount,
      code: supplierCode,
      particular: supplierName,
      Discription: "Purchasing items",
      cheque: "",
      billno: "",
      transactionType: "Debit",
      type: voucher.type,
      id:  voucher.id,
      site: voucher.site,
    },
    {
      transaction: "Credit",
      debit: "",
      credit: amount,
      amount: amount,
      code: "18-002-0001",
      particular: "Material Supplier",
      Discription: "Material Supplier",
      cheque: "",
      billno: "",
      transactionType: "",
      type: voucher.type,
      id: voucher.id,
      site: voucher.site,
    },
  ];

  console.log("voucher", voucher);
  return "";

  try {
    let voucherSupplyData = {
      ...genericVoucherData,
      debitTotal: amount,
      amountPaid: amountPaid,
      level3Code: supplierCode,
      voucherRecCode: dataCash[1],
      voucherParticular: dataCash[0],
      voucherDesc: "Supply Credit",
      type: "SUPPLY",
    };

    console.log("SUPPLY", voucherSupplyData, amount);
    let result = await saveNewVoucher("SUPPLY", voucherSupplyData, amount);

    if (amountPaid > 0) {
      let voucherRecCode = dataCash[1];
      let voucherParticular = dataCash[0];
      let voucherDesc = "Cash payment on delivery.";
      let voucherData = {
        ...genericVoucherData,
        debitTotal: amountPaid,
        level3Code: supplierCode,
        type: "CPV",
        voucherRecCode,
        voucherParticular,
        voucherDesc,
      };
      let result = await saveNewVoucher("CPV", voucherData, amount);
    }
    return "done";
  } catch (error) {
    console.log(error);
    return error;
  }
}
export async function createPaymentVoucher(
  debitInfo,
  creditInfo,
  voucherType,
  amount
) {
  let voucherData = {
    ...genericVoucherData,
    type: voucherType, // "CRV",
    amount: amount,
    creditTotal: amount,
    voucherItems: [
      {
        transaction: "Debit",
        debit: amount,
        credit: "",
        amount: amount,
        code: debitInfo.code,
        particular: debitInfo.particular,
        Discription: debitInfo.Discription,
        cheque: "",
        billno: "",
        transactionType: "Debit",
        type: voucherType,
        id: 1,
        site: 1,
      },
      {
        transaction: "Credit",
        debit: "",
        credit: amount,
        amount: amount,
        code: creditInfo.code,
        particular: creditInfo.particular,
        Discription: creditInfo.Discription,
        cheque: "",
        billno: "",
        transactionType: "Credit",
        type: voucherType,
        id: 2,
        site: 1,
      },
    ],
  };

  let result = await saveNewVoucher("CRV", voucherData, amount);
  return result;
}
export async function createCustomerSaleVoucher(
  customerCode,
  customerName,
  amount,
  amountPaid
) {
  try {
    const accountData = await nbfgetAccountSetting();
    let dataCash = accountData.PaymentCash.split(",").map((item) =>
      item.trim()
    );

    let voucherSaleData = {
      ...genericVoucherData,
      creditTotal: amount,
      amountPaid: amountPaid,
      level3Code: customerCode,
      voucherRecCode: dataCash[1],
      voucherParticular: dataCash[0],
      voucherDesc: "Sales Credit",
      type: "SALE",
    };

    console.log("SALE", voucherSaleData, amount);
    let result = await saveNewVoucher("SALE", voucherSaleData, amount);

    if (amountPaid > 0) {
      await createPaymentVoucher(
        {
          code: "07-001-0001",
          particular: "Cash payment",
          Discription: "Cash payment",
        },
        {
          code: customerCode,
          particular: "key customer",
          Discription: "Cash payment on delivery.",
        },
        "CRV",
        amount
      );
      // let result = await saveNewVoucher("CRV", voucherData, amount);
    }
    return "done";
  } catch (error) {
    console.log(error);
    return error;
  }
}
